export default __webpack_public_path__ + "static/media/zoology.94086431.png";